import React from "react";
import { BADGE_TEXT_SIZE_CLASSES } from "@/utils/typographyTokens";

/**
 * GenLP.ai Badge - A floating 3D card badge that links to genlp.ai
 * This component is displayed at the bottom of all landing pages
 */
const GenLPBadge: React.FC = () => (
  <div className="flex justify-center py-4 bg-transparent" dir="ltr">
    <a
      href="https://genlp.ai"
      target="_blank"
      rel="noopener noreferrer"
      className="group inline-flex items-center gap-3 px-5 py-3 bg-transparent rounded-xl hover:-translate-y-1 transition-all duration-300"
    >
      <div className="relative">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-purple-600 to-violet-600 flex items-center justify-center shadow-lg shadow-purple-500/30">
          <svg
            className="w-5 h-5 text-white"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        </div>
        <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-white dark:border-gray-800 flex items-center justify-center">
          <svg
            className="w-2 h-2 text-white"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </div>
      <div className="flex flex-col">
        <span className="text-xs text-gray-500 dark:text-gray-400 font-medium">
          AI-Generated Website
        </span>
        <span className={`${BADGE_TEXT_SIZE_CLASSES.sm} font-bold text-gray-900 dark:text-white`}>
          GenLP.ai
        </span>
      </div>
      <svg
        className="w-4 h-4 text-gray-400 group-hover:text-purple-600 group-hover:translate-x-1 transition-all"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 5l7 7-7 7"
        />
      </svg>
    </a>
  </div>
);

export default GenLPBadge;
